import React from 'react';

import { BaseTheme, ThemeType } from '../types';

import {
  DefaultHeaderLogo,
  DefaultLeftBackgroundImage,
  DefaultRightBackgroundImage,
} from './icons/default';

const baseTheme: BaseTheme = {
  backgroundColor: '#F8F8F9',
  textColor: '#585C62',
};

export const defaultReckonTheme: ThemeType = {
  tenant: 'RECKON',
  product: 'default',
  baseTheme: baseTheme,
  productTheme: {
    headerLogo: <DefaultHeaderLogo />,
    leftBackgroundImage: <DefaultLeftBackgroundImage />,
    rightBackgroundImage: <DefaultRightBackgroundImage />,
  },
};
